import {
  LibraryUpdate,
  OnboardingChecklist,
  TrackerNewFeatureBanner,
  useIsLibraryUpdateVisible,
  useIsOnboardingChecklistVisible,
  useIsTrackerNewFeaturesModalVisible,
} from './components';

export const Announcements = () => {
  const isOnboardingChecklistVisible = useIsOnboardingChecklistVisible();
  const isLibraryUpdateVisible = useIsLibraryUpdateVisible();
  const isTrackerNewFeaturesModalVisible =
    useIsTrackerNewFeaturesModalVisible();

  if (isOnboardingChecklistVisible) {
    return <OnboardingChecklist />;
  }

  if (isLibraryUpdateVisible) {
    return <LibraryUpdate />;
  }

  if (isTrackerNewFeaturesModalVisible) {
    return <TrackerNewFeatureBanner />;
  }
};
